import { isClientId } from '@/common/network/gql-types.ts'
import type { PropertyOptionModel } from '@/generated/graphql.ts'
import type { PropertyType } from '@/object-types/gql/PropertyType.ts'

export interface UpdatePropertyDefinitionInput {
  id: number
  name?: string
  options?: UpdatePropertyOptionsInput
}

export class UpdatePropertyOptionsInput {
  public createInputs?: CreatePropertyOptionInput[]
  public updates?: UpdatePropertyOptionInput[]
  public toDelete?: number[]

  constructor(init?: Partial<UpdatePropertyOptionsInput>) {
    Object.assign(this, init)
  }
}

export class CreatePropertyOptionInput {
  public value: string

  constructor(init?: Partial<CreatePropertyOptionInput>) {
    Object.assign(this, init)
  }
}

export class UpdatePropertyOptionInput {
  public id: number
  public value?: string
  public color?: string

  constructor(init?: Partial<UpdatePropertyOptionInput>) {
    Object.assign(this, init)
  }
}

export type LocalUpdatePropertyDefinitionInput = Omit<
  UpdatePropertyDefinitionInput,
  'options' | 'id'
> & {
  options?: LocalUpdatePropertyOptionsInput
  type?: PropertyType
}

export interface LocalUpdatePropertyOptionsInput {
  locallyCreatedOptions?: PropertyOptionModel[]
  updates?: LocalUpdatePropertyOptionInput[]
  toDelete?: number[]
}

export type LocalUpdatePropertyOptionInput = Omit<UpdatePropertyOptionInput, 'id'> & {
  id: number
}

export function localUpdPropDefInputToRemote(
  localInput: LocalUpdatePropertyDefinitionInput,
  propDefId: number,
): UpdatePropertyDefinitionInput {
  let options: UpdatePropertyOptionsInput | undefined = undefined
  if (localInput.options) {
    options = new UpdatePropertyOptionsInput({
      updates: localInput.options.updates?.filter(
        (x) => !isClientId(x.id),
      ) as UpdatePropertyOptionInput[],
      toDelete: localInput.options.toDelete?.filter((x) => !isClientId(x)),
    })
    options.createInputs = localInput.options.locallyCreatedOptions?.map((x) => ({
      value: x.value,
    }))
  }

  return {
    id: propDefId,
    name: localInput.name,
    options,
  }
}
